module.exports = __webpack_public_path__ + "img/melia-restaurant.63aea422.jpg";